import {
    balance,
    currency,
    gameRoundInfo,
    autoBetCount,
    roundTime,
    skipHappen
} from '@root/src/store';
import { get } from 'svelte/store';
// import { getNormalizeNumberWithDecimals, getUrlParam } from '@src/utils/global';
import { gameInitParams } from './misc';
import { trackEvent } from '../utils/init-analytics';
import { assert, getNormalizeNumberWithDecimals } from '../utils/global';
import { PlayResponse } from '../types';
import { EventEmitterInstance } from '@src/utils/event-emitter';
import { calculateTotalBet, getBetPerColor } from '../betting/betting';
import dayjs from 'dayjs';
import { betPerColor } from '@root/src/store/chips';

const interactionTypes = ['1', '2', '5', '10', 'BS', 'PL', 'CR', 'FW'];

const colors = ['BLACK', 'LIGHT_BLUE', 'PURPLE', 'ORANGE', 'PINK', 'BLUE', 'YELLOW', 'GREEN'];

EventEmitterInstance.on('analytics-bet-ui-interaction-center-left', () => {
    const $balance = get(balance);
    const $currency = get(currency);
    trackEvent('bet_ui_interaction', {
        $balance,
        $currency,
        interaction_type: 'bet_on_nums'
    });
});

EventEmitterInstance.on('analytics-bet-ui-interaction-center-right', () => {
    const $balance = get(balance);
    const $currency = get(currency);
    trackEvent('bet_ui_interaction', {
        $balance,
        $currency,
        interaction_type: 'bet_on_bonus'
    });
});

EventEmitterInstance.on('analytics-bet-ui-interaction', (type: number | string) => {
    if (typeof type === 'number') {
        if (!interactionTypes[type]) assert('unknow interaction type');

        type = 'bet_on_' + interactionTypes[type];
    }

    const $balance = get(balance);
    const $currency = get(currency);
    trackEvent('bet_ui_interaction', {
        $balance,
        $currency,
        interaction_type: type
    });
});

EventEmitterInstance.on('analytics-make-bet', () => {
    const $balance = get(balance);
    const $currency = get(currency);
    const $betPerColor = get(betPerColor); 
    const betArray = getBetPerColor();

    for (let i = 0; i < betArray.length; i++) {
        if (betArray[i] != 0) {
            let betType = 'color';
            if (i < 4) betType = 'usual';

            const $autoBetCount = get(autoBetCount);
            trackEvent('make_bet', {
                $balance,
                $currency,
                bet_type: betType,
                amount: $betPerColor[i].toString(),
                bet_target: interactionTypes[i],
                autobet_status: $autoBetCount > 0 ? 'on' : 'off',
                autobet_counter: $autoBetCount.toString()
            });
        }
    }
});

// need add skipgame,skiptime
EventEmitterInstance.on('analytics-game-finished', (win, win_amount) => {
    const $gameRoundInfo: PlayResponse = get(gameRoundInfo);
    if (!$gameRoundInfo || !$gameRoundInfo.resp) return;
    const $balance = get(balance);
    const $currency = get(currency);
    const $skipHappen = get(skipHappen);
    const $betPerColor = get(betPerColor); 

    const $gameInitParams = get(gameInitParams);
    const currencyExponent = $gameInitParams?.currency_attributes?.exponent;
    const currencySubunits = $gameInitParams?.currency_attributes?.subunits;

    const id = colors.findIndex((value: string) => value === $gameRoundInfo.resp.color);

    let positionBetsCount = 0;
    const betArray = getBetPerColor();
    for (let i = 0; i < betArray.length; i++) {
        if (betArray[i] != 0) positionBetsCount++;
    }

    const $roundTime = get(roundTime);
    const timeFromStartToPressSkip = dayjs.duration(dayjs().diff($roundTime?.from)).asSeconds();

    trackEvent('game_finished', {
        $balance,
        $currency,
        result: win ? 'WIN' : 'LOSE',
        won_amount: win_amount ? getNormalizeNumberWithDecimals(win_amount, currencyExponent, currencySubunits) : 0,
        autobet_status: get(autoBetCount) > 0 ? 'on' : 'off',
        total_bets: calculateTotalBet(),
        bet_type: 'COLOR',
        multiplier: $gameRoundInfo.resp?.top_slot?.multiplier,
        features_enabled: $gameInitParams,
        round_result: interactionTypes[id],
        position_bets_count: positionBetsCount,
        game_id: $gameRoundInfo.resp?.game_type,
        amount: $betPerColor.reduce((acc, value) => acc + value, 0).toString(),
        skip_time: timeFromStartToPressSkip,
        skip_game: $skipHappen ? 'yes' : 'no'
    });
});

EventEmitterInstance.on('analytics-skip-game', () => {
    const $balance = get(balance);
    const $currency = get(currency);
    const $roundTime = get(roundTime);
    const timeFromStartToPressSkip = dayjs.duration(dayjs().diff($roundTime?.from)).asSeconds();

    skipHappen.set(true);

    trackEvent('skip_game', {
        $balance,
        $currency,
        skip_time: timeFromStartToPressSkip,
        autobet_mode: get(autoBetCount) > 0 ? 'yes' : 'no'
    });
});

EventEmitterInstance.on('analytics-click-change-bet-amount', () => {
    const $balance = get(balance);
    const $currency = get(currency);

    trackEvent('click_change_bet_amount', {
        $balance,
        $currency
    });
});

EventEmitterInstance.on('analytics-change-bet-amount', (newVal) => {
    const $balance = get(balance);
    const $currency = get(currency);

    trackEvent('change_bet_amount', {
        $balance,
        $currency,
        amount: newVal
    });
});
